// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-default {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  height: 100%;
  position: fixed;
  backdrop-filter: blur(4px);
}
.modal-default .close-page {
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: transparent;
}
.modal-default .btn-close {
  top: 20px;
  right: 15px;
  position: absolute;
}
.modal-default .wrapper-modal {
  bottom: 0;
  z-index: 2;
  width: 100%;
  padding: 16px;
  overflow: auto;
  max-height: 90vh;
  position: absolute;
  border-radius: 4px;
  border: 2px solid #CFE2FC;
  background-color: var(--sebrae-white);
  box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);
}
.modal-default .wrapper-modal.square {
  border-radius: 0;
}
.modal-default .modal-header {
  border-bottom: 1px solid #e0e5eb;
  margin: 0 -16px;
  padding: 0 16px;
  margin-bottom: 16px;
}
.modal-default .title {
  color: #243342;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
  padding-bottom: 15px;
}
@media (min-width: 660px) {
  .modal-default {
    height: 100%;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }
  .modal-default .btn-close {
    display: block;
  }
  .modal-default .wrapper-modal {
    width: 100%;
    height: auto;
    max-width: 540px;
    position: relative;
    padding: 20px 30px 32px;
    background-color: var(--sebrae-white);
    box-shadow: 0 1px 30px 0 rgba(20, 46, 82, 0.2);
  }
  .modal-default .wrapper-modal.square {
    border-radius: 0;
  }
  .modal-default .modal-header {
    margin: 0 -30px;
    padding: 0 30px;
    margin-bottom: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modal-default/index.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AACF;AACE;EACE,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AAEE;EACE,SAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAGE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,gDAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,gCAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAHJ;AAME;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAJJ;AAOE;EA3DF;IA4DI,YAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,6BAAA;EAJF;EAME;IACE,cAAA;EAJJ;EAOE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,uBAAA;IACA,qCAAA;IACA,8CAAA;EALJ;EAOI;IACE,gBAAA;EALN;EASE;IACE,eAAA;IACA,eAAA;IACA,mBAAA;EAPJ;AACF","sourcesContent":[".modal-default {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 10;\n  height: 100%;\n  position: fixed;\n  backdrop-filter: blur(4px);\n\n  .close-page {\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background-color: transparent;\n  }\n\n  .btn-close {\n    top: 20px;\n    right: 15px;\n    position: absolute;\n  }\n\n  .wrapper-modal {\n    bottom: 0;\n    z-index: 2;\n    width: 100%;\n    padding: 16px;\n    overflow: auto;\n    max-height: 90vh;\n    position: absolute;\n    border-radius: 4px;\n    border: 2px solid #CFE2FC;\n    background-color: var(--sebrae-white);\n    box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);\n\n    &.square {\n      border-radius: 0;\n    }\n  }\n\n  .modal-header {\n    border-bottom: 1px solid #e0e5eb;\n    margin: 0 -16px;\n    padding: 0 16px;\n    margin-bottom: 16px;\n  }\n\n  .title {\n    color: #243342;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 23.3px;\n    padding-bottom: 15px;\n  }\n\n  @media (min-width: 660px) {\n    height: 100%;\n    display: flex;\n    position: fixed;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n\n    .btn-close {\n      display: block;\n    }\n\n    .wrapper-modal {\n      width: 100%;\n      height: auto;\n      max-width: 540px;\n      position: relative;\n      padding: 20px 30px 32px;\n      background-color: var(--sebrae-white);\n      box-shadow: 0 1px 30px 0 rgba(20, 46, 82, 0.2);\n\n      &.square {\n        border-radius: 0;\n      }\n    }\n\n    .modal-header {\n      margin: 0 -30px;\n      padding: 0 30px;\n      margin-bottom: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
